import {useCallback, useContext, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {selectEditorDisabled} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {Range} from '~/common/fabric/CreateDesign/components/CardEditor/components/Range/Range';
import {FabricContext} from '~/common/fabric/context/FabricContext';

export const LetterSpacing = () => {
  const {canvas, activeObjects} = useContext(FabricContext);
  const [charSpacing, setCharSpacing] = useState();
  const editorDisabled = useSelector(selectEditorDisabled);

  useEffect(() => {
    setCharSpacing(canvas?.getActiveObjects()?.[0]?.charSpacing);
    canvas?.on('object:reset', () => setCharSpacing(canvas?.getActiveObjects()?.[0]?.charSpacing));
  }, [canvas]);

  const onChangeHandler = useCallback(
    (value) => {
      activeObjects.forEach((obj) => {
        setCharSpacing(value);
        obj.set('charSpacing', value);
      });

      canvas.requestRenderAll();
      canvas.fire('object:modified');
    },
    [activeObjects, canvas]
  );

  return (
    <Range
      min={0}
      max={100}
      step="10"
      suffix="%"
      onChange={onChangeHandler}
      value={charSpacing}
      disabled={editorDisabled}
      dataQaId="step1-textspacing-range"
    />
  );
};
